/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetOwnerPersonToken} from '../api'

export const useMutationBatchGetOwnerPersonToken = createReactQueryMutationHook('batchGetOwnerPersonToken', batchGetOwnerPersonToken)
